import { render, staticRenderFns } from "./TransactionMetadata.vue?vue&type=template&id=528df57c&"
import script from "./TransactionMetadata.vue?vue&type=script&lang=js&"
export * from "./TransactionMetadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports